var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_827_35004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.468 38.0449C141.53 23.5518 126.457 8.47559 111.961 4.53809C103.072 2.32324 91.166 0.0410156 75 0C58.8398 0.0410156 46.9336 2.32324 38.0449 4.53809C23.5518 8.47559 8.47559 23.5488 4.53809 38.0449C2.32324 46.9307 0.0410156 58.8398 0 75C0.0410156 91.1631 2.32324 103.069 4.53809 111.958C8.47559 126.454 23.5518 141.527 38.0449 145.465C46.9336 147.68 58.8457 149.962 75.0029 150C91.1631 149.962 103.072 147.68 111.961 145.465C126.457 141.527 141.53 126.454 145.468 111.958C147.683 103.069 149.965 91.1572 150.003 75C149.965 58.8398 147.683 46.9336 145.468 38.0449Z",
    fill: "#F6EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 25.1719C65.1448 25.1719 55.511 28.0943 47.3167 33.5696C39.1224 39.0449 32.7358 46.8272 28.9646 55.9323C25.1933 65.0373 24.2067 75.0563 26.1295 84.7221C28.0524 94.3879 32.7984 103.266 39.7673 110.235C46.7361 117.203 55.6149 121.949 65.2808 123.871C74.9467 125.793 84.9656 124.806 94.0704 121.034C103.175 117.263 110.957 110.875 116.432 102.681C121.907 94.4863 124.829 84.8523 124.828 74.9971C124.827 61.7823 119.577 49.1091 110.233 39.7652C100.888 30.4212 88.2148 25.1719 75 25.1719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6875 98.3711C58.4794 98.3711 57.5 97.3918 57.5 96.1836V56.8086C57.5 55.6005 58.4794 54.6211 59.6875 54.6211H90.3125C91.5207 54.6211 92.5 55.6005 92.5 56.8086V96.1836C92.5 97.3918 91.5207 98.3711 90.3125 98.3711H59.6875ZM81.5625 85.2461L92.5 76.4961L81.5625 67.7461V74.3086H68.4375V78.6836H81.5625V85.2461Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_827_35004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.baa46d7a784554a210fb35094af68314.svg";
export { ForwardRef as ReactComponent };